import React from 'react';

import FixedImage from 'src/components/common/fixed-image';
import DavidLloydLogo from 'src/components/icons/david-lloyd-logo';
import { BuildType } from 'src/enums/build/build-type';
import {
  harbourLogoImage,
  lightBgBlackMeridianLogoImage,
  togetherFoundationLogoImage,
} from 'src/helpers/fixed-images/logo-images';

import * as styles from './brand-logo.module.scss';

type BrandLogoProps = {
  buildType: BuildType;
};

const BrandLogo = ({ buildType }: BrandLogoProps) => {
  if (buildType === BuildType.MERIDIAN) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.meridianInner}>
          <FixedImage imageDetails={lightBgBlackMeridianLogoImage} />
        </div>
      </div>
    );
  }

  if (buildType === BuildType.HARBOUR) {
    return (
      <div className={styles.wrapper}>
        <FixedImage imageDetails={harbourLogoImage} />
      </div>
    );
  }

  if (buildType === BuildType.TOGETHER_FOUNDATION) {
    return (
      <div className={styles.wrapper}>
        <FixedImage imageDetails={togetherFoundationLogoImage} />
      </div>
    );
  }

  return <DavidLloydLogo size="11.25rem" />;
};

export { BrandLogo };
